import { useAuth } from '@/contexts/AuthContext'
import { getRoleDisplayName } from '@/utils/permissions'
import { AlertTriangle, X } from 'lucide-react'

/**
 * Banner displayed when a super admin is viewing the app as another role
 * Shows the impersonated role and provides a button to exit impersonation
 */
export function ImpersonationBanner() {
  const { isImpersonating, effectiveRole, setImpersonatedRole, user } = useAuth()

  // Only show banner when impersonating
  if (!isImpersonating || user?.role !== 'super_admin') {
    return null
  }

  return (
    <div className="bg-amber-500 text-amber-950">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="w-4 h-4" />
          <span className="text-sm font-medium">
            Viewing as: <strong>{getRoleDisplayName(effectiveRole)}</strong>
          </span>
          <span className="text-sm text-amber-800">
            (Your actual role: Super Admin)
          </span>
        </div>
        <button
          onClick={() => setImpersonatedRole(null)}
          className="flex items-center gap-1.5 px-3 py-1 text-sm font-medium bg-amber-600 hover:bg-amber-700 text-white rounded-md transition-colors"
        >
          <X className="w-4 h-4" />
          Exit Impersonation
        </button>
      </div>
    </div>
  )
}
